<template lang="pug">
.question_wide.d-flex.flex-column
  img(:src="question.FAQWideCoverImage")
  .title_btn.d-flex.align-items-center.justify-content-between(
    @click="toDetail"
  )
    h5.i_body.i_mt_3 {{ question.FAQTitle }}
    svg-icon(iconClass="arrow_bottom_g", className="arrow_bottom_g")
  .divider.i_mt-3
  p.i_mt_4 {{ question.FAQBrief }}
</template>

<script>
export default {
  name: "QuestionWide",
  props: {
    question: Object,
    selected: Boolean,
  },
  components: {},
  methods: {
    toDetail() {
      this.$router.push({
        name: "CustomerServiceFAQDetail",
        query: { id: this.question.FAQID },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/question_wide";
</style>
